<template>
  <el-dialog 
    :title="getDialogTitle" 
    :visible.sync="dialogVisible" 
    width="88%" 
    :close-on-click-modal="false"
    :before-close="handleClose" 
    top="2vh" 
    custom-class="addxyk-dialog"
  >
    <div class="dialog-container">
      <!-- 上部分：采购信息 -->
      <div class="purchase-info-section">
        <h3 class="section-title">采购信息</h3>
        <el-form 
          ref="purchaseForm" 
          :model="purchaseForm" 
          :rules="purchaseRules" 
          label-width="120px" 
          size="mini"
        >
          <el-row :gutter="20">
            <!-- 出库药库 -->
            <el-col :span="8">
              <el-form-item label="出库药库：" prop="warehouseId">
                <el-select 
                  v-model="purchaseForm.warehouseId" 
                  placeholder="请选择出库药库" 
                  clearable
                  style="width: 100%"
                  @change="handleWarehouseChange"
                  :disabled="true"
                  size="mini"
                >
                  <el-option
                    v-for="item in warehouseOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            
            <!-- 业务日期（禁用状态默认当前日期） -->
            <el-col :span="8">
              <el-form-item label="业务日期：" prop="businessDate">
                <el-date-picker
                  v-model="purchaseForm.businessDate"
                  type="date"
                  placeholder="选择日期"
                  style="width: 100%"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :disabled="true"
                  size="mini"
                />
              </el-form-item>
            </el-col>
            
            <!-- 出库科室 -->
            <el-col :span="8">
              <el-form-item label="出库科室：" prop="deptId">
                <el-select
                  v-model="purchaseForm.deptId"
                  placeholder="请选择出库科室"
                  clearable
                  style="width: 100%"
                  :disabled="currentMode !== 'add' && currentMode !== 'edit'"
                  size="mini"
                >
                  <el-option
                    v-for="item in deptOptions"
                    :key="item.id"
                    :label="item.deptName"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <!-- 供货单位 + 供应商号码 -->
            <el-col :span="8">
              <el-form-item label="供货单位：" prop="supplierId">
                <div class="supplier-container">
                  <el-select
                    v-model="purchaseForm.supplierId"
                    placeholder="请选择供货单位"
                    clearable
                    style="flex: 1"
                    :disabled="currentMode !== 'add' && currentMode !== 'edit'"
                    @change="handleSupplierChange"
                    size="mini"
                  >
                    <el-option
                      v-for="item in supplierOptions"
                      :key="item.id"
                      :label="item.supplierName"
                      :value="item.id"
                    />
                  </el-select>
                  <el-input
                    v-model="purchaseForm.supplierNo"
                    placeholder="供应商号码"
                    style="width: 150px; margin-left: 10px"
                    :disabled="currentMode !== 'add' && currentMode !== 'edit'"
                    size="mini"
                  />
                </div>
              </el-form-item>
            </el-col>
            
            <!-- 出库方式 -->
            <el-col :span="6">
              <el-form-item label="出库方式：" prop="outTypeId">
                <el-select
                  v-model="purchaseForm.outTypeId"
                  placeholder="请选择出库方式"
                  clearable
                  style="width: 100%"
                  :disabled="currentMode !== 'add' && currentMode !== 'edit'"
                  size="mini"
                >
                  <el-option
                    v-for="item in outTypeOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            
            <!-- 备注 -->
            <el-col :span="10">
              <el-form-item label="备注：" prop="remarks">
                <el-input
                  v-model="purchaseForm.remarks"
                  placeholder="请输入备注"
            	  type="textarea"
                  :disabled="currentMode !== 'add' && currentMode !== 'edit'"
                  size="mini"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      
      <!-- 下部分：药品出库明细列表 -->
      <div class="medicine-detail-section">
        <!-- 在药品出库明细列表标题右侧 -->
        <div class="section-header">
          <h3 class="section-title">药品出库明细列表</h3>
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-plus"
            @click="addMedicineRow"
            v-if="currentMode === 'add' || currentMode === 'edit'"
            :disabled="!purchaseForm.warehouseId"
          >
            添加药品
          </el-button>
        </div>
        
        <!-- 药品明细表格 -->
        <el-table
          :data="medicineList"
          style="width: 100%"
          stripe
          border
          size="mini"
          max-height="400px"
          v-loading="tableLoading"
        >
          <!-- 行号 -->
          <el-table-column
            type="index"
            label="#"
            width="60"
            align="center"
            fixed
          />
          
          <!-- 药品名称 -->
          <el-table-column
            prop="drugName"
            label="药品名称"
            min-width="180"
            align="center"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.isLocked && !scope.row.isEditing">
                {{ scope.row.drugName || '--' }}
              </template>
              <template v-else>
                <!-- 药品名称下拉框 -->
                <el-select
                  v-model="scope.row.drugId"
                  placeholder="请选择药品"
				  :popper-class="'zyk-outbound-drug-select-popper'"
                  clearable
                  filterable
                  style="width: 100%"
                  :disabled="(currentMode === 'edit' && scope.row.isLocked && !scope.row.isEditing) || currentMode === 'view' || currentMode === 'submit' || currentMode === 'review' || currentMode === 'pass'"
                  @change="(value) => handleDrugChange(value, scope.row, scope.$index)"
                  size="mini"
                >
                  <!-- 修改key绑定，使用复合key避免重复 -->
                  <el-option
                    v-for="(item, index) in drugOptions"
                    :key="`${item.drugId}-${index}`"
                    :label="item.drugName"
                    :value="item.drugId"
                  >
                    <div style="display: flex;flex-direction: column;line-height: 1.4; padding: 8px 0;">
                      <div style="display: flex; justify-content: space-between; align-items: center;">
                        <span style="font-weight: 500; color: #303133;">{{ item.drugName }}</span>
                        <span style="font-size: 12px; color: #8492a6;">批次号：{{ item.manuLotnum || '无批次' }}</span>
                      </div>
                      <div style="font-size: 12px; color: #606266; margin-top: 4px;">
                        规格：{{ item.drugSpec }}
                      </div>
                    </div>
                  </el-option>
                  
                  <!-- 加载更多选项 -->
                  <el-option
                    v-if="drugOptions.length > 0 && drugOptions.length < totalDrugs"
                    key="load-more"
                    disabled
                    style="text-align: center;"
                  >
                    <el-button
                      type="text"
                      size="mini"
                      :loading="drugLoading"
                      @click="loadMoreDrugs"
                      style="width: 100%;"
                    >
                      加载更多...
                    </el-button>
                  </el-option>
                  
                  <!-- 无数据提示 -->
                  <el-option
                    v-if="!drugLoading && drugOptions.length === 0"
                    key="no-data"
                    disabled
                    style="text-align: center; color: #909399;"
                  >
                    暂无数据
                  </el-option>
                </el-select>
              </template>
            </template>
          </el-table-column>
          
          <!-- 出库数量 -->
          <el-table-column
            label="出库数量"
            width="140"
            align="center"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.isLocked && !scope.row.isEditing">
                {{ scope.row.outQuantity || '--' }}{{ scope.row.unit ? ' ' + scope.row.unit : '' }}
              </template>
              <template v-else>
                <div class="out-quantity-container" style="display: flex; align-items: center; gap: 8px;">
                  <!-- 出库数量输入框 -->
                  <el-input
                    v-model="scope.row.outQuantity"
                    placeholder="请输入数量"
                    style="width: 120px"
                    :disabled="currentMode !== 'add' && currentMode !== 'edit' || (scope.row.isLocked && !scope.row.isEditing) || !scope.row.drugId"
                    @input="(value) => handleQuantityChange(value, scope.row, scope.$index)"
                    size="mini"
                  />
                  <!-- 单位文字独立显示 -->
                  <span style="color: #606266; font-size: 12px; min-width: 30px;">
                    {{ scope.row.unit || '--' }}
                  </span>
                </div>
              </template>
            </template>
          </el-table-column>
          
          <!-- 库存类型 -->
          <el-table-column
            label="库存类型"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.isLocked && !scope.row.isEditing">
                {{ scope.row.stockType === 1 ? '最小单位' : '包装单位' }}
              </template>
              <template v-else>
                <!-- 库存类型下拉框 -->
                <el-select
                  v-model="scope.row.stockType"
                  placeholder="库存类型"
                  style="width: 100%"
                  :disabled="currentMode !== 'add' && currentMode !== 'edit' || (scope.row.isLocked && !scope.row.isEditing)"
                  @change="(value) => handleStockTypeChange(value, scope.row)"
                  size="mini"
                >
                  <el-option label="最小单位" :value="1" />
                  <el-option label="包装单位" :value="2" />
                </el-select>
              </template>
            </template>
          </el-table-column>
          
          <!-- 包装数量 -->
          <el-table-column
            prop="pacCnt"
            label="包装数量"
            width="90"
            align="center"
			show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.pacCnt || '--' }}
            </template>
          </el-table-column>
          <!-- 实际库存数量 -->
          <el-table-column
            prop="purcCnt"
            label="实际库存数量"
            width="100"
            align="center"
			show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.purcCnt || '--' }}
            </template>
          </el-table-column>
		  
		  <!-- 当前出库成本列 -->
		  <el-table-column
		    prop="currentOutCost"
		    label="当前出库成本"
		    width="160"
		    align="center"
		  >
		    <template slot-scope="scope">
		      <!-- 锁定且非编辑状态：只读显示 -->
		      <template v-if="scope.row.isLocked && !scope.row.isEditing">
		        <span v-if="scope.row.currentOutCost !== undefined && scope.row.currentOutCost !== null && scope.row.currentOutCost !== ''">
		          ¥{{ formatAmount(scope.row.currentOutCost) }}
		        </span>
		        <span v-else>--</span>
		      </template>
		      <!-- 编辑/新增状态：可输入 -->
		      <template v-else>
		        <div style="display: flex; align-items: center; gap: 2px; justify-content: center;">
		          <el-input
		            v-model="scope.row.currentOutCost"
		            placeholder="请输入成本"
		            size="mini"
		            style="width: 140px;"
		            :disabled="(currentMode !== 'add' && currentMode !== 'edit') || (!scope.row.isEditing && scope.row.isLocked) || !scope.row.drugId"
		            @change="(value) => handleCurrentOutCostChange(value, scope.row, scope.$index)"
		            @blur="(event) => handleCurrentOutCostBlur(event, scope.row, scope.$index)"
		            clearable
		          >
		            <template slot="append">元</template>
		          </el-input>
		        </div>
		      </template>
		    </template>
		  </el-table-column>
		  
		  <!-- 当前出库零售 -->
		  <el-table-column
		    prop="currentOutSale"
		    label="当前出库零售"
		    width="140"
		    align="center"
		  >
		    <template slot-scope="scope">
		      <span v-if="scope.row.currentOutSale !== undefined && scope.row.currentOutSale !== null && scope.row.currentOutSale !== ''">
		        ¥{{ formatAmount(scope.row.currentOutSale) }}
		      </span>
		      <span v-else>--</span>
		    </template>
		  </el-table-column>
		  
          <!-- 生产厂家 -->
          <el-table-column
            prop="prodentpName"
            label="生产厂家"
            width="150"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.prodentpName || '--' }}
            </template>
          </el-table-column>
          
          <!-- 生产批号 -->
          <el-table-column
            prop="manuLotnum"
            label="生产批号"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.manuLotnum || '--' }}
            </template>
          </el-table-column>
          
          <!-- 生产日期 -->
          <el-table-column
            prop="manuDate"
            label="生产日期"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              {{ formatDate(scope.row.manuDate) || '--' }}
            </template>
          </el-table-column>
          
          <!-- 有效期 -->
          <el-table-column
            prop="expyDate"
            label="有效期"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              {{ formatDate(scope.row.expyDate) || '--' }}
            </template>
          </el-table-column>
          
          <!-- 入库成本 -->
          <el-table-column
            prop="purcPric"
            label="入库成本"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.purcPric !== undefined && scope.row.purcPric !== null">
                ¥{{ formatAmount(scope.row.purcPric) }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          
          <!-- 入库零售 -->
          <el-table-column
            prop="salePric"
            label="入库零售"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.salePric !== undefined && scope.row.salePric !== null">
                ¥{{ formatAmount(scope.row.salePric) }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          
          <!-- 规格 -->
          <el-table-column
            prop="drugSpec"
            label="规格"
            width="120"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.drugSpec || '--' }}
            </template>
          </el-table-column>
          
          <!-- 库存ID -->
          <el-table-column
            prop="invId"
            label="库存ID"
            width="100"
            align="center"
            v-if="currentMode === 'view'"
          >
            <template slot-scope="scope">
              {{ scope.row.invId || '--' }}
            </template>
          </el-table-column>
          
          <!-- 操作列 -->
          <el-table-column
            label="操作"
            width="150"
            align="center"
            fixed="right"
            v-if="currentMode === 'add' || currentMode === 'edit'"
          >
            <template slot-scope="scope">
              <!-- 锁定状态：修改、移除 -->
              <template v-if="scope.row.isLocked && !scope.row.isEditing">
                <!-- 修改按钮 -->
                <el-button
                  type="text"
                  size="mini"
                  @click="handleEditRow(scope.row, scope.$index)"
                  v-if="currentMode === 'edit'"
                >
                  修改
                </el-button>
                
                <!-- 移除按钮 -->
                <el-button
                  type="text"
                  size="mini"
                  style="color: #F56C6C;"
                  @click="handleRemoveRow(scope.row, scope.$index)"
                >
                  移除
                </el-button>
              </template>
              
              <!-- 编辑状态：取消、移除 -->
              <template v-else-if="scope.row.isEditing">
                <!-- 修改模式下不显示保存按钮，只显示取消和移除 -->
                <!-- 取消按钮 -->
                <el-button
                  type="text"
                  size="mini"
                  class="cancel-btn"
                  @click="handleCancelEdit(scope.row, scope.$index)"
                >
                  取消
                </el-button>
                
                <!-- 移除按钮 -->
                <el-button
                  type="text"
                  size="mini"
                  style="color: #F56C6C;"
                  @click="handleRemoveRow(scope.row, scope.$index)"
                >
                  移除
                </el-button>
              </template>
              
              <!-- 新增状态：移除 -->
              <template v-else>
                <!-- 新增模式下只显示移除按钮 -->
                <el-button
                  type="text"
                  size="mini"
                  style="color: #F56C6C;"
                  @click="handleRemoveRow(scope.row, scope.$index)"
                >
                  移除
                </el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
        
        <!-- 合计行 -->
        <div class="summary-row" v-if="medicineList.length > 0">
          <div class="summary-item">
            <span class="summary-label">总出库数量：</span>
            <span class="summary-value">{{ totalOutQuantity }}</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">总出库成本：</span>
            <span class="summary-value">¥{{ formatAmount(totalOutCost) }}</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">总出库零售：</span>
            <span class="summary-value">¥{{ formatAmount(totalOutSale) }}</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 模态框底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <!-- 查看模式 -->
      <template v-if="currentMode === 'view'">
        <el-button @click="handlePrint" size="mini" :disabled="true">打印</el-button>
        <el-button @click="handleScreenshot" size="mini" type="primary" :disabled="true">截图保存</el-button>
        <el-button @click="handleClose" size="mini">关闭</el-button>
      </template>
      
      <!-- 新增模式 -->
      <template v-else-if="currentMode === 'add'">
        <el-button @click="handleClose" size="mini">关闭</el-button>
        <el-button 
          @click="handleSaveDraft" 
          size="mini" 
          type="info"
          :disabled="!canSave"
          :loading="submitLoading"
        >
          存为草稿
        </el-button>
        <el-button 
          @click="handleSaveSubmit" 
          size="mini" 
          type="primary"
          :disabled="!canSave"
          :loading="submitLoading"
        >
          保存提交
        </el-button>
      </template>
      
      <!-- 修改模式 -->
      <template v-else-if="currentMode === 'edit'">
        <el-button @click="handleClose" size="mini">关闭</el-button>
        <el-button 
          @click="handleSaveDraft" 
          size="mini" 
          type="info"
          :disabled="!canSave"
          :loading="submitLoading"
        >
          保存草稿
        </el-button>
        <el-button 
          @click="handleSaveSubmit" 
          size="mini" 
          type="primary"
          :disabled="!canSave"
          :loading="submitLoading"
        >
          保存提交
        </el-button>
      </template>
      
      <!-- 提交模式 -->
      <template v-else-if="currentMode === 'submit'">
        <el-button @click="handleClose" size="mini">关闭</el-button>
        <el-button 
          @click="handleSubmitReview" 
          size="mini" 
          type="primary"
          :loading="submitLoading"
        >
          提交审核
        </el-button>
      </template>
      
      <!-- 审核模式 -->
      <template v-else-if="currentMode === 'review'">
        <el-button @click="handleClose" size="mini">关闭</el-button>
        <el-button @click="handleRollbackDraft" size="mini" type="warning">回退草稿</el-button>
        <el-button 
          @click="handleReviewPass" 
          size="mini" 
          type="primary"
          :loading="submitLoading"
        >
          审核过单
        </el-button>
      </template>
      
      <!-- 过单模式 -->
      <template v-else-if="currentMode === 'pass'">
        <el-button @click="handleClose" size="mini">关闭</el-button>
        <el-button @click="handleRollbackSubmit" size="mini" type="warning">回退提交</el-button>
        <el-button 
          @click="handlePassOutbound" 
          size="mini" 
          type="primary"
          :loading="submitLoading"
        >
          过单出库
        </el-button>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import { addSupplierEntity,docMarkById } from "@/api/PSI.js";
import { findAttribute } from "@/api/user.js"
import {
  selectDropDownList,
  selectZYDrug,
  addZYOutbound,
  selectZYtoYKDrug,
  toZYRetnExamine,
  editZYdocOut,
  selectOut,
  docOutZYJoin
} from "@/api/PSI/shopReturn.js";

export default {
  name: 'AddZykModal',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    mode: {
      type: String,
      default: 'add' // add, edit, view, submit, review, pass
    },
    rowData: {
      type: Object,
      default: () => ({})
    },
    putinTypeList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: false,
      currentMode: 'add',
      purchaseForm: {
        warehouseId: 3, // 出库药库，默认3中药库
        businessDate: this.getCurrentDate(), // 业务日期
        invoiceNo: '', // 发票号码
        supplierId: '', // 供货单位ID
        supplierNo: '', // 供应商号码
        outTypeId: 11, // 出库方式ID，默认11采购退库
        remarks: '' // 备注
      },
	  searchQuery: '', // 搜索关键词
	  loadingMore: false, // 是否正在加载更多
	  showLoadMore: false, // 是否显示加载更多按钮
	  isSearching: false, // 是否正在搜索
      purchaseRules: {
        warehouseId: [
          { required: true, message: '请选择出库药库', trigger: 'change' }
        ],
        businessDate: [
          { required: true, message: '请选择业务日期', trigger: 'change' }
        ],
        supplierId: [
          { required: true, message: '请选择供货单位', trigger: 'change' }
        ],
        outTypeId: [
          { required: true, message: '请选择出库方式', trigger: 'change' }
        ]
      },
      warehouseOptions: [
        { id: 3, name: '中药库' },
      ],
      userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
      supplierOptions: [], // 供货单位选项
      deptOptions: [], // 出库科室选项
      outTypeOptions: [], // 出库方式选项
      medicineList: [], // 药品明细列表
      drugOptions: [], // 药品选项
      tableLoading: false,
      submitLoading: false,
      drugLoading: false,
      
      // 分页参数
      pageNum: 1,
      pageSize: 50,
      totalDrugs: 0,
      drugName: '', // 药品搜索名称
      
      // 当前编辑的行索引
      editingRowIndex: -1
    };
  },
  computed: {
    getDialogTitle() {
        const titleMap = {
          'add': '创建中药库出库单',
          'edit': `修改 - ${this.rowData?.docNum || ''}`,
          'view': `查看出库单-${this.rowData?.docNum || ''}的详情`,
          'submit': `提交${this.rowData?.docNum || ''}的出库单`,
          'review': `审核${this.rowData?.docNum || ''}的出库单`,
          'pass': `确认过单${this.rowData?.docNum || ''}完成出库`
        };
        return titleMap[this.currentMode] || '出库单';
	},
	// 总出库数量
	totalOutQuantity() {
	  // 统一计算每行出库数量的累加
	  return this.medicineList.reduce((total, item) => {
	    const quantity = parseFloat(item.outQuantity) || 0;
	    return total + quantity;
	  }, 0);
	},
	// 总出库成本（使用当前出库成本累加）
	totalOutCost() {
	  return this.medicineList.reduce((total, item) => {
	    const cost = parseFloat(item.currentOutCost) || 0;
	    return total + cost;
	  }, 0);
	},
	// 总出库零售（使用当前出库零售累加）
	totalOutSale() {
	  return this.medicineList.reduce((total, item) => {
	    const sale = parseFloat(item.currentOutSale) || 0;
	    return total + sale;
	  }, 0);
	},
    // 是否可以保存（新增/修改模式下）
    canSave() {
      console.log('检查是否可以保存，当前模式:', this.currentMode);
      
      // 只有在新增和修改模式下才需要检查保存条件
      if (this.currentMode !== 'add' && this.currentMode !== 'edit') {
        return true;
      }
      
      // 检查必填字段
      if (!this.purchaseForm.warehouseId || 
          !this.purchaseForm.supplierId || 
          !this.purchaseForm.outTypeId) {
        console.log('采购信息不完整，缺少必填字段');
        return false;
      }
      
      // 检查药品明细列表是否有数据
      if (this.medicineList.length === 0) {
        console.log('药品明细列表为空');
        return false;
      }
      
      // 检查是否有行处于编辑状态
      const hasEditingRows = this.medicineList.some(item => item.isEditing);
      if (hasEditingRows) {
        console.log('有行处于编辑状态，禁用底部按钮');
        return false;
      }
      
      // 新增模式和修改模式的区别处理
      if (this.currentMode === 'add') {
        // 新增模式下，检查所有行是否都已通过库存验证
        for (let i = 0; i < this.medicineList.length; i++) {
          const item = this.medicineList[i];
          console.log(`新增模式 - 第${i + 1}行状态:`, {
            drugName: item.drugName,
            isLocked: item.isLocked,
            verified: item.verified,
            outQuantity: item.outQuantity,
            drugId: item.drugId
          });
          
          // 在新增模式下，检查行是否已验证
          if (!item.isLocked && !item.verified) {
            console.log(`第${i + 1}行未验证，禁用底部按钮`);
            return false;
          }
          
          // 检查是否有必需的药品信息
          if (!item.drugId || !item.outQuantity) {
            console.log(`第${i + 1}行缺少药品信息或出库数量`);
            return false;
          }
        }
      } else if (this.currentMode === 'edit') {
        // 修改模式下，检查所有行是否都已锁定
        for (let i = 0; i < this.medicineList.length; i++) {
          const item = this.medicineList[i];
          console.log(`修改模式 - 第${i + 1}行状态:`, {
            drugName: item.drugName,
            isLocked: item.isLocked,
            isEditing: item.isEditing
          });
          
          if (!item.isLocked) {
            console.log(`第${i + 1}行未锁定，禁用底部按钮`);
            return false;
          }
        }
      }
      
      console.log('所有条件满足，启用底部按钮');
      return true;
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.dialogVisible = newVal;
        if (newVal) {
          this.initData();
        }
      }
    },
    mode: {
      immediate: true,
      handler(newVal) {
        this.currentMode = newVal;
      }
    },
    rowData: {
      immediate: true,
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.loadRowData(newVal);
        } else {
          this.resetPurchaseForm();
        }
      }
    },
    'purchaseForm.warehouseId': {
      handler(newVal) {
        if (newVal) {
          this.loadDrugOptions();
        } else {
          this.drugOptions = [];
        }
      }
    }
  },
  mounted() {
    this.loadSupplierOptions();
	this.fetchDeptOptions();
    this.loadOutTypeOptions();
  },
  beforeDestroy() {
    // 移除滚动事件监听
    const popper = document.querySelector('.drug-select-popper .el-select-dropdown__wrap');
    if (popper) {
      popper.removeEventListener('scroll', this.handleSelectScroll);
    }
  },
  methods: {
    // 获取当前日期
    getCurrentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    
    // 初始化数据
    async initData() {
      if (this.currentMode === 'add') {
        this.resetPurchaseForm();
        this.medicineList = [];
        // 加载药品选项
        this.loadDrugOptions();
      }
    },
    
    // 加载供货单位选项
    async loadSupplierOptions() {
      try {
        const response = await selectDropDownList();
        if (response && response.code === 200 && response.data) {
          this.supplierOptions = response.data.content;
        } else {
          this.supplierOptions = [];
        }
      } catch (error) {
        console.error('加载供货单位列表失败:', error);
        this.$message.error('加载供货单位列表失败');
        this.supplierOptions = [];
      }
    },
    
	// 获取科室选项
	async fetchDeptOptions() {
		try {
			const clinicId = this.userInfo.clinicId
			if (clinicId) {
				const res = await findAttribute({
					clinicId
				})
				if (res && res.data) {
					this.deptOptions = res.data
					console.log('获取科室选项111:', this.deptOptions)
				}
			}
		} catch (error) {
			console.error('获取科室选项失败:', error)
		}
	},
	
    // 加载出库方式选项
    async loadOutTypeOptions() {
      try {
        const response = await selectOut();
        if (response && response.code === 200 && response.data) {
          this.outTypeOptions = response.data;
        } else {
          this.outTypeOptions = [];
        }
      } catch (error) {
        console.error('加载出库方式列表失败:', error);
        this.$message.error('加载出库方式列表失败');
        this.outTypeOptions = [];
      }
    },
    
    // 加载药品选项
    async loadDrugOptions(isLoadMore = false) {
      if (!this.purchaseForm.warehouseId) {
        this.drugOptions = [];
        return;
      }
      
      try {
        this.drugLoading = true;
        let response = null;
        const params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          drugName: this.drugName
        };
        
        if (this.purchaseForm.warehouseId === 3) {
          // 中药库
          response = await selectZYDrug(params);
        } else if (this.purchaseForm.warehouseId === 4) {
          // 中药房
          response = await selectZYtoYKDrug(params);
        }
        
        if (response && response.code === 200) {
          const newDrugs = response.data.content || response.data || [];
          if (isLoadMore) {
            // 加载更多，合并数据
            this.drugOptions = [...this.drugOptions, ...newDrugs];
          } else {
            // 新搜索，替换数据
            this.drugOptions = newDrugs;
          }
          this.totalDrugs = response.data.totalSize || 0;
        } else {
          this.drugOptions = [];
          this.totalDrugs = 0;
        }
      } catch (error) {
        console.error('加载药品列表失败:', error);
        this.$message.error('加载药品列表失败');
        this.drugOptions = [];
        this.totalDrugs = 0;
      } finally {
        this.drugLoading = false;
      }
    },
    
    // 添加远程搜索方法
    handleRemoteSearch(query) {
      console.log('远程搜索:', query);
      this.searchQuery = query;
      this.pageNum = 1;
      this.isSearching = true;
      this.loadDrugOptions();
    },
    
    // 添加选择框获取焦点方法
    handleSelectFocus() {
      if (this.drugOptions.length === 0 && !this.drugLoading) {
        this.pageNum = 1;
        this.searchQuery = '';
        this.isSearching = false;
        this.loadDrugOptions();
      }
    },
    
    // 添加选择框显示/隐藏变化方法
    handleSelectVisibleChange(visible) {
      if (visible && this.drugOptions.length === 0 && !this.drugLoading) {
        this.pageNum = 1;
        this.searchQuery = '';
        this.isSearching = false;
        this.loadDrugOptions();
      }
    },
    
    // 添加加载更多方法
    loadMoreDrugs() {
      if (this.loadingMore) return;
      
      this.pageNum++;
      this.loadDrugOptions(true);
    },
    
    // 修改药品搜索方法
    handleDrugSearch() {
      this.pageNum = 1;
      this.isSearching = true;
      this.loadDrugOptions();
    },
    
    // 处理选择框显示/隐藏
    handleSelectVisible(visible) {
      if (visible) {
        // 选择框显示时，绑定滚动事件
        this.$nextTick(() => {
          this.bindSelectScroll();
        });
      }
    },
    
    // 绑定选择框滚动事件
    bindSelectScroll() {
      const popper = document.querySelector('.drug-select-popper .el-select-dropdown__wrap');
      if (popper) {
        popper.addEventListener('scroll', this.handleSelectScroll);
      }
    },
    
    // 处理选择框滚动
    handleSelectScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      const threshold = 50; // 距离底部50px时触发加载
      
      // 如果滚动到底部，并且还有更多数据，则加载更多
      if (scrollHeight - scrollTop - clientHeight < threshold) {
        if (!this.drugLoading && this.drugOptions.length < this.totalDrugs) {
          this.loadMoreDrugs();
        }
      }
    },
	
    // 在loadRowData方法中修改
    loadRowData(rowData) {
      console.log('加载行数据:', rowData);
      
      // 填充采购信息
      this.purchaseForm = {
        warehouseId: rowData.shedId || 3,
		deptId: rowData.deptId,
        businessDate: rowData.businessDate || this.getCurrentDate(),
        invoiceNo: rowData.invoiceNo || '',
        supplierId: rowData.supplyCandidateId || null,
        supplierNo: rowData.supplierNo || '',
        outTypeId: rowData.retnTypeId || 11,
        remarks: rowData.remarks || ''
      };
      
      // 加载药品明细
      if (rowData.list && Array.isArray(rowData.list)) {
        this.medicineList = rowData.list.map(item => {
          // 在详情、修改、提交、审核、过单模式下，出库数量取retnCnt
          const outQuantity = ['view', 'edit', 'submit', 'review', 'pass'].includes(this.currentMode) 
            ? (item.retnCnt || item.apllyAmt || '')
            : (item.apllyAmt || '');
          
          // 计算当前出库成本和零售
          const currentOutCost = parseFloat(item.retnAmt) || 0;
          const currentOutSale = parseFloat(item.saleAmt) || 0;
          
          return {
            id: item.id || null,
            drugId: item.drugId || null,
            drugName: item.drugName || '',
            purcCnt: item.purcCnt || '',
			retailUnitPrice: '',  // 新增
            outQuantity: outQuantity,
            stockType: item.purcType || 2,
            pacCnt: item.pacCnt || '',
            prodentpName: item.prodentpName || '',
            manuLotnum: item.manuLotnum || '',
            manuDate: item.manuDate || '',
            expyDate: item.expyDate || '',
            purcPric: item.retnPric || '',
            currentOutCost: currentOutCost,
            salePric: item.salePric || '',
            currentOutSale: currentOutSale,
            drugSpec: item.drugSpec || '',
            unit: item.unt || '',
            dosUnt: item.dosUnt || '',
            pacUnt: item.pacUnt || '',
            invId: item.invId || null,
            prodentpNameId: item.prodentpNameId || null,
            isLocked: true,
            isEditing: false,
            hasChanged: false,
            originalData: JSON.parse(JSON.stringify(item))
          };
        });
      } else {
        this.medicineList = [];
      }
      
      // 如果有关联药库，加载对应药品选项
      if (rowData.shedId) {
        this.loadDrugOptions();
      }
    },
    
    // 重置采购表单
    resetPurchaseForm() {
      this.purchaseForm = {
        warehouseId: 3, // 默认中药库
        businessDate: this.getCurrentDate(),
        invoiceNo: '',
        supplierId: null,
        supplierNo: '',
        outTypeId: 11, // 默认采购退库
        remarks: ''
      };
      this.medicineList = [];
      this.pageNum = 1;
      this.drugName = '';
    },
    
	addMedicineRow() {
	  const newRow = {
	    id: null,
	    drugId: null,
	    drugName: '',
	    purcCnt: '',
	    outQuantity: '',
	    stockType: 2,
	    currentOutCost: '',
	    currentOutSale: '',
	    retailUnitPrice: '',  // 新增：存储零售单价（单位零售价）
	    pacCnt: '',
	    prodentpName: '',
	    manuLotnum: '',
	    manuDate: '',
	    expyDate: '',
	    purcPric: '',
	    salePric: '',
	    drugSpec: '',
	    unit: '',
	    dosUnt: '',
	    pacUnt: '',
	    invId: null,
	    prodentpNameId: null,
	    isLocked: false,
	    isEditing: this.currentMode === 'edit',
	    hasChanged: false,
	    checkingStock: false,
	    verified: this.currentMode === 'add',
	    verificationResult: null,
	    originalData: null
	  };
     
     if (this.currentMode === 'add') {
       newRow.verified = false;
     }
     
     this.medicineList.push(newRow);
     console.log(`新增药品行（模式：${this.currentMode}），isEditing: ${newRow.isEditing}，当前行数:`, this.medicineList.length);
	},
    
	// 保存已验证的行
	handleSaveVerifiedRow(row, index) {
	  if (!row.verified) {
	    this.$message.warning('该行尚未通过库存验证');
	    return;
	  }
	  
	  // 锁定已验证的行
	  row.isLocked = true;
	  row.isEditing = false;
	  row.verified = false;
	  row.originalData = JSON.parse(JSON.stringify(row));
	  
	  this.$message.success('已保存药品信息');
	},
	
    // 处理药库变更
    handleWarehouseChange(value) {
      this.medicineList.forEach(item => {
        if (!item.isLocked) {
          // 重置非锁定的药品行
          this.resetMedicineRow(item);
        }
      });
      this.loadDrugOptions();
    },
    
    // 处理供货单位变更
    handleSupplierChange(value) {
      const selectedSupplier = this.supplierOptions.find(item => item.id === value);
      if (selectedSupplier && selectedSupplier.supplierNo) {
        this.purchaseForm.supplierNo = selectedSupplier.supplierNo;
      }
    },
    
	// 判断是否显示当前库存列
	shouldShowPurcCnt(index) {
	  const row = this.medicineList[index];
	  
	  // 在详情、提交、审核、过单模式下不显示
	  if (['view', 'submit', 'review', 'pass'].includes(this.currentMode)) {
	    return false;
	  }
	  
	  // 在修改模式下
	  if (this.currentMode === 'edit') {
	    // 如果行处于锁定状态且不是编辑状态，不显示
	    if (row.isLocked && !row.isEditing) {
	      return false;
	    }
	    // 如果行处于编辑状态但没有选择药品，不显示
	    if (row.isEditing && !row.drugId) {
	      return false;
	    }
	  }
	  
	  return true;
	},
	
    // 处理药品选择变更
    handleDrugChange(drugId, row, index) {
      console.log('药品选择变更:', drugId, '行索引:', index);
      
      if (!drugId) {
        console.log('清空药品选择');
        this.resetMedicineRow(row);
        row.hasChanged = this.checkRowChanged(row);
        return;
      }
      
      const selectedDrug = this.drugOptions.find(item => item.drugId === drugId);
      if (selectedDrug) {
        console.log('找到选中药品:', selectedDrug);
        
        // 填充药品信息
        row.drugName = selectedDrug.drugName;
        row.purcCnt = selectedDrug.purcCnt || '';
        row.pacCnt = selectedDrug.pacCnt || '';
        row.manuLotnum = selectedDrug.manuLotnum || '';
        row.prodentpName = selectedDrug.prodentpName || '';
        row.manuDate = selectedDrug.manuDate || '';
        row.expyDate = selectedDrug.expyDate || '';
        // 获取入库成本 - 从selectDrug接口返回的purcPric
        row.purcPric = selectedDrug.purcPric || '';
        row.salePric = selectedDrug.salePric || '';
        row.drugSpec = selectedDrug.drugSpec || '';
        row.dosUnt = selectedDrug.dosUnt || '';
        row.pacUnt = selectedDrug.pacUnt || '';
        
        // 关键：保存库存ID
        row.invId = selectedDrug.invyId || selectedDrug.invId || null;
        console.log('保存库存ID:', row.invId);
        
        row.prodentpNameId = selectedDrug.prodentpNameId || null;
        row.unit = row.pacUnt; // 默认显示包装单位
        
        // 清除验证状态，因为药品已更改
        row.verified = false;
        row.verificationResult = null;
        
        // 注意：不再自动将 currentOutCost 设为 0
        // 保留用户之前输入的值，或者如果为空则保持为空
        
        // 如果当前出库成本为空且有入库成本，可设置为入库成本 * 出库数量的初始值（但用户可修改）
        if ((row.currentOutCost === undefined || row.currentOutCost === null || row.currentOutCost === '') && 
            row.purcPric && parseFloat(row.purcPric) > 0 && row.outQuantity && parseFloat(row.outQuantity) > 0) {
          // 可选：不自动填充，让用户手动输入
          // row.currentOutCost = parseFloat(row.purcPric) * parseFloat(row.outQuantity);
        }
        
        // 计算当前出库成本和零售（仅作为初始参考，不覆盖用户输入）
        // 如果有出库数量且用户未输入成本，可以设置初始值但不清空已有值
        if (row.outQuantity && parseFloat(row.outQuantity) > 0) {
          // 如果用户尚未输入成本，可设置初始值
          if (row.currentOutCost === undefined || row.currentOutCost === null || row.currentOutCost === '') {
            // 不自动填充，保持为空，让用户手动输入
          }
        }
        
        row.hasChanged = this.checkRowChanged(row);
        
        console.log(`药品${selectedDrug.drugName}信息已填充，入库成本:`, row.purcPric, '当前出库成本:', row.currentOutCost);
      } else {
        console.log('未找到对应药品，drugId:', drugId);
      }
    },
    
    // 处理出库数量变更
    handleQuantityChange(value, row, index) {
      const numValue = parseFloat(value);
      if (isNaN(numValue) || numValue <= 0) {
        this.$message.warning('出库数量必须为大于0的数字');
        row.outQuantity = '';
        row.currentOutCost = 0;
        row.currentOutSale = 0;
        row.retailUnitPrice = '';
        row.hasChanged = this.checkRowChanged(row);
        return;
      }
      
      // 检查是否为小数
      if (numValue % 1 !== 0) {
        row.stockType = 1;
        row.unit = row.dosUnt;
      } else {
        if (!row.stockType) {
          row.stockType = 2;
          row.unit = row.pacUnt;
        }
      }
      
      // 关键：重新计算当前出库零售
      // 如果已有零售单价，直接乘以新数量
      if (row.retailUnitPrice && parseFloat(row.retailUnitPrice) > 0) {
        row.currentOutSale = parseFloat(row.retailUnitPrice) * numValue;
      } else if (row.currentOutCost && parseFloat(row.currentOutCost) > 0 && row.drugId) {
        // 如果没有零售单价但有成本，尝试调用 docMarkById 获取单价（避免丢失）
        // 但为了防止频繁调用，这里先不做自动调用，只保留成本不变，零售重新计算由后续操作触发
        // 或者可以在这里主动调用一次，但为了性能，建议用户修改成本或类型时触发
        // 简单处理：如果没有零售单价，则零售置空或根据成本*数量简单计算（不准确）
        // 更稳健：如果成本存在但无单价，调用计算
        this.calculateRetailPriceByDocMark(row, parseFloat(row.currentOutCost));
      } else {
        row.currentOutSale = '';
      }
      
      row.hasChanged = this.checkRowChanged(row);
      
      // 原有的自动验证逻辑不变
      if (this.currentMode === 'edit' && row.isEditing && row.drugId && row.outQuantity && row.invId) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.autoStockCheck(row, index, true);
          }, 300);
        });
      } else if (this.currentMode === 'add' && row.drugId && row.outQuantity && row.invId) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.autoStockCheck(row, index, true);
          }, 300);
        });
      }
    },
    
    // 处理库存类型变更
    handleStockTypeChange(value, row) {
      console.log('库存类型变更:', value, '当前出库数量:', row.outQuantity);
      
      row.stockType = value;
      row.unit = value === 1 ? row.dosUnt : row.pacUnt;
      
      // 如果已有当前出库成本，重新调用 docMarkById 计算零售
      if (row.currentOutCost && parseFloat(row.currentOutCost) > 0 && row.drugId) {
        this.calculateRetailPriceByDocMark(row, parseFloat(row.currentOutCost));
      } else {
        // 如果没有成本，清空零售
        row.currentOutSale = '';
        row.retailUnitPrice = '';
      }
      
      row.hasChanged = this.checkRowChanged(row);
      
      // 原有的自动验证逻辑
      if (row.drugId && row.outQuantity && row.invId) {
        if (this.currentMode === 'edit' && row.isEditing) {
          this.autoStockCheck(row, this.medicineList.indexOf(row), true);
        } else if (this.currentMode === 'add') {
          this.$nextTick(() => {
            setTimeout(() => {
              this.autoStockCheck(row, this.medicineList.indexOf(row), true);
            }, 300);
          });
        }
      }
    },
    
	// 格式化小数，保留指定位数
	formatDecimal(value, maxDecimals = 8) {
	  if (value === null || value === undefined || value === '') return '0';
	  const num = parseFloat(value);
	  if (isNaN(num)) return '0';
	  const decimalPlaces = (num.toString().split('.')[1] || '').length;
	  const places = Math.min(decimalPlaces, maxDecimals);
	  return num.toFixed(places);
	},
	
	/**
	 * 处理当前出库成本变化
	 * 调用 docMarkById 接口计算零售价
	 */
	async handleCurrentOutCostChange(value, row, index) {
	  if (value === undefined || value === null || value === '') {
	    row.currentOutCost = '';
	    row.currentOutSale = '';
	    row.retailUnitPrice = '';
	    return;
	  }
	  const costValue = parseFloat(value);
	  if (isNaN(costValue) || costValue < 0) {
	    this.$message.warning('请输入有效的正数');
	    row.currentOutCost = '';
	    row.currentOutSale = '';
	    row.retailUnitPrice = '';
	    return;
	  }
	  row.currentOutCost = costValue;
	  
	  if (row.drugId && costValue > 0) {
	    await this.calculateRetailPriceByDocMark(row, costValue);
	  } else {
	    row.currentOutSale = '';
	    row.retailUnitPrice = '';
	  }
	},
	
	/**
	 * 当前出库成本输入框失去焦点
	 */
	handleCurrentOutCostBlur(event, row, index) {
	  if (row.currentOutCost === undefined || row.currentOutCost === null || row.currentOutCost === '') {
	    row.currentOutCost = '';
	    row.currentOutSale = '';
	  } else {
	    // 确保是数字
	    const num = parseFloat(row.currentOutCost);
	    if (!isNaN(num)) {
	      row.currentOutCost = num;
	    }
	  }
	},
	
	/**
	 * 根据当前出库成本调用 docMarkById 计算零售价
	 */
	async calculateRetailPriceByDocMark(row, costValue) {
	  const purcType = row.stockType || 2;
	  const drugId = row.drugId;
	  const quantity = parseFloat(row.outQuantity) || 1;
	  
	  if (!drugId || costValue <= 0) {
	    row.currentOutSale = '';
	    row.retailUnitPrice = '';
	    return;
	  }
	  
	  try {
	    const response = await docMarkById({
	      drugId: drugId,
	      costPric: costValue,
	      purcType: purcType,
	      drugType: 9
	    });
	    
	    if (response && response.code === 200 && response.data) {
	      const data = response.data;
	      let retailPrice = 0;
	      if (purcType === 1) {
	        retailPrice = data.minSalePrice || costValue;
	      } else {
	        retailPrice = data.pacSalePrice || costValue;
	      }
	      row.retailUnitPrice = retailPrice;  // 存储零售单价
	      row.currentOutSale = retailPrice * quantity;
	    } else {
	      row.currentOutSale = costValue * quantity;
	      row.retailUnitPrice = costValue;
	    }
	  } catch (error) {
	    console.error('计算中药零售价失败:', error);
	    row.currentOutSale = costValue * quantity;
	    row.retailUnitPrice = costValue;
	  }
	},
	
	// 自动库存验证
	async autoStockCheck(row, index, isManual = false) {
	  if (!row.drugId || !row.outQuantity) {
	    return;
	  }
	  
	  // 检查是否有invId
	  if (!row.invId) {
	    this.$message.warning('未获取到库存ID，请重新选择药品');
	    return;
	  }
	  
	  // 防止频繁调用
	  if (row.checkingStock) {
	    return;
	  }
	  
	  try {
	    row.checkingStock = true;
	    this.tableLoading = true;
	    
	    const params = {
	      amount: row.outQuantity, // 出库数量
	      invId: row.invId, // 库存ID
	      purcType: row.stockType // 库存类型
	    };
	    
	    console.log('自动库存验证参数:', params);
	    
	    const response = await docOutZYJoin(params);
	    if (response && response.code === 200) {
	      // 验证成功
	      if (this.currentMode === 'edit' && row.isEditing) {
	        // 修改模式下，验证成功，锁定行并退出编辑状态
	        row.isLocked = true;
	        row.isEditing = false;
	        row.hasChanged = false;
	        row.originalData = JSON.parse(JSON.stringify(row));
	        
	        // 隐藏操作列中的保存按钮
	        this.editingRowIndex = -1;
	        
	        this.$message.success(`已成功将${row.drugName}修改并锁定`);
	      } else if (this.currentMode === 'add') {
	        // 新增模式下，验证成功，标记为已验证
	        row.verified = true;
	        row.hasChanged = false;
	        
	        this.$message.success(`已成功将${row.drugName}添加至出库明细表！`);
	      }
	      
	      // 验证成功后，只更新入库成本和入库零售（不再更新当前出库成本和零售）
	      if (response.data && response.data.length > 0) {
	        const firstItem = response.data[0];
	        console.log('docOutZYJoin接口返回的数据:', firstItem);
	        
	        // 更新入库成本 - 将接口返回的retnPric赋值到入库成本字段
	        row.purcPric = firstItem.retnPric || row.purcPric;
	        row.salePric = firstItem.salePric || row.salePric;
	        
	        // 注意：不再通过此接口更新 currentOutCost 和 currentOutSale
	        // 这两个字段现在由用户手动输入成本 + docMarkById 计算零售
	      }
	    } else {
	      // 验证失败
	      this.$message.error(response?.message || '库存验证失败');
	      
	      if (this.currentMode === 'edit' && row.isEditing) {
	        // 修改模式下验证失败，保持编辑状态，不锁定
	        row.isLocked = false;
	        row.isEditing = true;
	        row.hasChanged = true;
	      } else if (this.currentMode === 'add') {
	        // 新增模式下验证失败
	        row.verified = false;
	        row.hasChanged = true;
	      }
	    }
	  } catch (error) {
	    console.error('自动库存验证失败:', error);
	    this.$message.error('库存验证失败，请稍后重试');
	    
	    if (this.currentMode === 'edit' && row.isEditing) {
	      row.isLocked = false;
	      row.isEditing = true;
	      row.hasChanged = true;
	    } else if (this.currentMode === 'add') {
	      row.verified = false;
	      row.hasChanged = true;
	    }
	  } finally {
	    row.checkingStock = false;
	    this.tableLoading = false;
	  }
	},
	
    // 计算当前行的出库成本和零售
    // 计算当前行的出库成本和零售（仅用于初始化，不再覆盖用户输入）
    calculateRowAmounts(row) {
      // 注意：当前出库成本现在由用户手动输入，不再自动计算
      // 当前出库零售由 docMarkById 接口计算
      // 此方法仅用于初始化或辅助计算，不覆盖用户输入的值
      
      // 如果当前出库成本为空，且入库成本存在，可设置初始提示值（但不强制）
      if ((row.currentOutCost === undefined || row.currentOutCost === null || row.currentOutCost === '') && 
          row.purcPric && parseFloat(row.purcPric) > 0) {
        // 可选：不自动填充，让用户手动输入
        // row.currentOutCost = parseFloat(row.purcPric) * (parseFloat(row.outQuantity) || 1);
      }
      
      // 当前出库零售由 docMarkById 计算，不在此处计算
    },
    
    // 重置药品行
    resetMedicineRow(row) {
      row.drugId = null;
      row.drugName = '';
      row.purcCnt = '';
      row.outQuantity = '';
      row.stockType = 2;
      row.pacCnt = '';
      row.prodentpName = ''; // 注意字段名
	  row.currentOutCost = '';
	  row.currentOutSale = '';
	  row.retailUnitPrice = '';
      row.manuLotnum = '';
      row.manuDate = '';
      row.expyDate = '';
      row.purcPric = '';
      row.currentOutCost = '';
      row.salePric = '';
      row.currentOutSale = '';
      row.drugSpec = '';
      row.unit = '';
      row.dosUnt = '';
      row.pacUnt = '';
      row.invId = null;
      row.prodentpNameId = null;
      row.hasChanged = this.checkRowChanged(row);
    },
    
    // 计算当前出库成本
    calculateCurrentOutCost(item) {
      const quantity = parseFloat(item.outQuantity) || 0;
      const costPrice = parseFloat(item.purcPric) || 0;
      return quantity * costPrice;
    },
    
    // 计算当前出库零售
    calculateCurrentOutSale(item) {
      const quantity = parseFloat(item.outQuantity) || 0;
      const salePrice = parseFloat(item.salePric) || 0;
      return quantity * salePrice;
    },
    
    // 检查行数据是否变化
    checkRowChanged(row) {
      if (!row.originalData) {
        // 如果没有原始数据，说明是新增行
        return !!(row.drugId || row.outQuantity);
      }
      
      // 比较关键字段是否变化
      return row.drugId !== row.originalData.drugId ||
             row.outQuantity !== row.originalData.outQuantity ||
             row.stockType !== row.originalData.stockType;
    },
    
	// 库存验证
	async handleStockCheck(row, index) {
	  if (!row.drugId || !row.outQuantity) {
	    this.$message.warning('请先选择药品并填写出库数量');
	    return;
	  }
	  
	  // 检查是否有invId
	  if (!row.invId) {
	    this.$message.warning('未获取到库存ID，请重新选择药品');
	    return;
	  }
	  
	  try {
	    this.tableLoading = true;
	    const params = {
	      amount: row.outQuantity, // 出库数量
	      invId: row.invId, // 库存ID
	      purcType: row.stockType // 库存类型
	    };
	    
	    console.log('库存验证参数:', params);
	    
	    const response = await docOutZYJoin(params);
	    if (response && response.code === 200) {
	      // 库存验证成功，但不更新金额字段
	      // 只锁定行状态
	      row.isLocked = true;
	      row.isEditing = false;
	      row.hasChanged = false;
	      row.originalData = JSON.parse(JSON.stringify(row));
	      
	      this.$message.success(`已为${row.drugName}完成库存验证`);
	    } else {
	      this.$message.error(response.message || '库存验证失败');
	    }
	  } catch (error) {
	    console.error('库存验证失败:', error);
	    this.$message.error('库存验证失败');
	  } finally {
	    this.tableLoading = false;
	  }
	},
    
    // 修改行
    handleEditRow(row, index) {
      row.isEditing = true;
      row.hasChanged = false;
      row.originalData = JSON.parse(JSON.stringify(row));
      this.editingRowIndex = index;
    },
    
    // 保存编辑
    async handleSaveEdit(row, index) {
      if (!row.drugId || !row.outQuantity) {
        this.$message.warning('请先选择药品并填写出库数量');
        return;
      }
      
      // 检查是否有invId
      if (!row.invId) {
        this.$message.warning('未获取到库存ID，请重新选择药品');
        return;
      }
      
      try {
        this.tableLoading = true;
        const params = {
          amount: row.outQuantity, // 出库数量
          invId: row.invId, // 库存ID
          purcType: row.stockType // 库存类型
        };
        
        const response = await docOutZYJoin(params);
        if (response && response.code === 200) {
          // 验证成功，锁定行并退出编辑状态
          row.isLocked = true;
          row.isEditing = false;
          row.hasChanged = false;
          row.originalData = JSON.parse(JSON.stringify(row));
          this.editingRowIndex = -1;
          
          // 验证成功后，更新金额字段
          if (response.data && response.data.length > 0) {
            const firstItem = response.data[0];
            console.log('保存编辑时接口返回的数据:', firstItem);
            
            // 更新入库成本 - 将接口返回的retnPric赋值到入库成本字段
            row.purcPric = firstItem.retnPric || row.purcPric;
            row.salePric = firstItem.salePric || row.salePric;
            
            // 计算当前出库成本 = 接口返回的retnPric * 接口返回的apllyAmt
            const retnPric = parseFloat(firstItem.retnPric) || 0;
            const apllyAmt = parseFloat(firstItem.apllyAmt) || 0;
            row.currentOutCost = retnPric * apllyAmt;
            
            // 计算当前出库零售 = 接口返回的salePric * 接口返回的apllyAmt
            const salePric = parseFloat(firstItem.salePric) || 0;
            row.currentOutSale = salePric * apllyAmt;
          }
          
          this.$message.success('修改已保存');
        } else {
          this.$message.error(response.message || '库存验证失败，保存未成功');
          
          // 验证失败，保持编辑状态，不锁定
          row.isLocked = false;
          row.isEditing = true; // 保持编辑状态
          row.hasChanged = true; // 保持有变化状态
        }
      } catch (error) {
        console.error('保存编辑失败:', error);
        this.$message.error('保存编辑失败');
        
        // 异常时也保持编辑状态，不锁定
        row.isLocked = false;
        row.isEditing = true;
        row.hasChanged = true;
      } finally {
        this.tableLoading = false;
      }
    },
    
    // 取消编辑
    handleCancelEdit(row, index) {
      if (row.originalData) {
        // 恢复原始数据
        Object.assign(row, row.originalData);
      }
      row.isEditing = false;
      row.hasChanged = false;
      this.editingRowIndex = -1;
    },
    
    // 移除行
    handleRemoveRow(row, index) {
      if (!row.drugId) {
        // 如果未选择药品，直接移除
        this.medicineList.splice(index, 1);
        this.$message.success('已移除');
        return;
      }
      
      // 如果已选择药品，弹出确认提示
      this.$confirm(
        '当前出库表格中您已选择了出库药库，可尝试重新填写其对应的明细，或者点击确定移除此行，进行重新编辑。',
        '确认移除',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        this.medicineList.splice(index, 1);
        this.$message.success('已移除');
      }).catch(() => {
        // 用户取消移除
      });
    },
    
    // 格式化金额（智能小数位数处理，限制最多8位小数）
    formatAmount(amount) {
      if (amount === undefined || amount === null || amount === '') return '0.00';
      
      // 转换为数字
      const num = parseFloat(amount);
      if (isNaN(num)) return '0.00';
      
      // 检查是否为整数
      if (num % 1 === 0) {
        // 整数，显示两位小数
        const fixedNum = num.toFixed(2);
        const parts = fixedNum.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return parts.join('.');
      } else {
        // 有小数
        // 转换为字符串，保留最多8位小数
        const numStr = num.toString();
        let parts = numStr.split('.');
        
        // 如果小数部分超过8位，截取前8位
        if (parts[1] && parts[1].length > 8) {
          parts[1] = parts[1].substring(0, 8);
        }
        
        // 去掉末尾的0
        if (parts[1]) {
          parts[1] = parts[1].replace(/0+$/, '');
          // 如果去掉0后没有小数了，添加.00
          if (parts[1] === '') {
            parts[1] = '00';
          }
        } else {
          parts[1] = '00';
        }
        
        // 整数部分添加千位分隔符
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        
        return parts.join('.');
      }
    },
    
    // 格式化日期
    formatDate(date) {
      if (!date) return '--';
      if (typeof date === 'string') {
        return date.split(' ')[0]; // 只取日期部分
      }
      if (typeof date === 'number') {
        return new Date(date).toISOString().split('T')[0];
      }
      return '--';
    },
    
    // 验证表单
    validateForm() {
      return new Promise((resolve, reject) => {
        this.$refs.purchaseForm.validate((valid) => {
          if (!valid) {
            this.$message.error('请填写完整的采购信息');
            reject(new Error('表单验证失败'));
            return;
          }
          
          if (this.medicineList.length === 0) {
            this.$message.error('请至少添加一条药品明细');
            reject(new Error('药品明细为空'));
            return;
          }
          
          // 验证药品明细
          // for (let i = 0; i < this.medicineList.length; i++) {
          //   const item = this.medicineList[i];
          //   if (!item.drugId) {
          //     this.$message.error(`第${i + 1}行：请选择药品`);
          //     reject(new Error(`第${i + 1}行药品未选择`));
          //     return;
          //   }
            
          //   if (!item.outQuantity || parseFloat(item.outQuantity) <= 0) {
          //     this.$message.error(`第${i + 1}行：请输入有效的出库数量`);
          //     reject(new Error(`第${i + 1}行出库数量无效`));
          //     return;
          //   }
            
          //   if (!item.isLocked) {
          //     this.$message.error(`第${i + 1}行：请先完成库存验证`);
          //     reject(new Error(`第${i + 1}行未完成库存验证`));
          //     return;
          //   }
          // }
          
          resolve();
        });
      });
    },
    
    // 准备提交数据
    prepareSubmitData(state) {
      // 计算总成本
      const costAmt = this.medicineList.reduce((total, item) => {
        const retnAmt = parseFloat(item.currentOutCost) || 0;
        return total + retnAmt;
      }, 0);
      
      // 计算总零售
      const saleAmt = this.medicineList.reduce((total, item) => {
        const saleAmtItem = parseFloat(item.currentOutSale) || 0;
        return total + saleAmtItem;
      }, 0);
      
      return {
        costAmt: costAmt, // 出库总成本
        list: this.medicineList.map(item => ({
          apllyAmt: parseFloat(item.outQuantity) || 0, // join接口返回的出库数量
          drugId: item.drugId, // 药品ID
          drugName: item.drugName, // 药品名称
          drugSpec: item.drugSpec, // 规格
          invId: item.invId || 0, // 库存ID
          manuLotnum: item.manuLotnum, // 生产批号
          prodentpName: item.prodentpName, // 生产厂家名称
          prodentpNameId: item.prodentpNameId || 0, // 生产厂家ID
          purcType: item.stockType, // 库存类型
          retnAmt: parseFloat(item.currentOutCost) || 0, // 出库总成本
          retnPric: parseFloat(item.purcPric) || 0, // 入库成本
          saleAmt: parseFloat(item.currentOutSale) || 0, // 出库总零售
          salePric: parseFloat(item.salePric) || 0, // 入库零售
          unt: item.stockType === 1 ? item.dosUnt : item.pacUnt // 出库单位
        })),
        remarks: this.purchaseForm.remarks, // 备注
        retnTypeId: this.purchaseForm.outTypeId, // 出库方式ID
		deptId: this.purchaseForm.deptId, // 出库科室ID
        saleAmt: saleAmt, // 出库总零售
        shedId: this.purchaseForm.warehouseId, // 出库药库ID
        state: state, // 状态：0草稿，2提交
        supplyCandidateId: this.purchaseForm.supplierId // 供货单位ID
      };
    },
    
    // 保存为草稿
    async handleSaveDraft() {
      try {
        await this.validateForm();
        this.submitLoading = true;
        
        const submitData = this.prepareSubmitData(0); // 草稿状态
        
        let response = null;
        if (this.currentMode === 'add') {
          response = await addZYOutbound(submitData);
        } else if (this.currentMode === 'edit') {
          response = await editZYdocOut({
            ...submitData,
            id: this.rowData.id
          });
        }
        
        if (response && response.code === 200) {
          const drugNames = this.medicineList.map(item => item.drugName).join('、');
          this.$message.success(`${this.purchaseForm.businessDate} - ${drugNames}出库单 已完成草稿状态的创建！`);
          this.$emit('success', {
            ...response.data,
            warehouseId: this.purchaseForm.warehouseId
          });
          this.handleClose();
        } else {
          this.$message.error(response.message || '保存草稿失败');
        }
      } catch (error) {
        if (error.message !== '表单验证失败' && 
            error.message !== '药品明细为空' && 
            !error.message.includes('未完成库存验证')) {
          console.error('保存草稿失败:', error);
          this.$message.error('保存草稿失败');
        }
      } finally {
        this.submitLoading = false;
      }
    },
    
    // 保存提交
    async handleSaveSubmit() {
      try {
        await this.validateForm();
        this.submitLoading = true;
        
        const submitData = this.prepareSubmitData(2); // 已提交状态
        
        let response = null;
        if (this.currentMode === 'add') {
          response = await addZYOutbound(submitData);
        } else if (this.currentMode === 'edit') {
          response = await editZYdocOut({
            ...submitData,
            id: this.rowData.id
          });
        }
        
        if (response && response.code === 200) {
          const drugNames = this.medicineList.map(item => item.drugName).join('、');
          this.$message.success(`${this.purchaseForm.businessDate} - ${drugNames}出库单 已完成提交状态的创建！`);
          this.$emit('success', {
            ...response.data,
            warehouseId: this.purchaseForm.warehouseId
          });
          this.handleClose();
        } else {
          this.$message.error(response.message || '保存提交失败');
        }
      } catch (error) {
        if (error.message !== '表单验证失败' && 
            error.message !== '药品明细为空' && 
            !error.message.includes('未完成库存验证')) {
          console.error('保存提交失败:', error);
          this.$message.error('保存提交失败');
        }
      } finally {
        this.submitLoading = false;
      }
    },
    
    // 提交审核
    async handleSubmitReview() {
      try {
        await this.validateForm();
        this.submitLoading = true;
        
        const submitData = this.prepareSubmitData(2); // 已提交状态
        
        const response = await toZYRetnExamine({
          ...submitData,
          id: this.rowData.id
        });
        
        if (response && response.code === 200) {
          this.$message.success('提交审核成功');
          this.$emit('success', response.data);
          this.handleClose();
        } else {
          this.$message.error(response.message || '提交审核失败');
        }
      } catch (error) {
        if (error.message !== '表单验证失败' && 
            error.message !== '药品明细为空' && 
            !error.message.includes('未完成库存验证')) {
          console.error('提交审核失败:', error);
          this.$message.error('提交审核失败');
        }
      } finally {
        this.submitLoading = false;
      }
    },
    
    // 审核过单
    async handleReviewPass() {
      try {
        this.submitLoading = true;
        
        const response = await toZYRetnExamine({
          id: this.rowData.id,
          state: 4 // 已审核状态
        });
        
        if (response && response.code === 200) {
          this.$message.success('审核过单成功');
          this.$emit('success', response.data);
          this.handleClose();
        } else {
          this.$message.error(response.message || '审核过单失败');
        }
      } catch (error) {
        console.error('审核过单失败:', error);
        this.$message.error('审核过单失败');
      } finally {
        this.submitLoading = false;
      }
    },
    
    // 过单出库
    async handlePassOutbound() {
      try {
        this.submitLoading = true;
        
        const response = await toZYRetnExamine({
          id: this.rowData.id,
          state: 5 // 已过单状态
        });
        
        if (response && response.code === 200) {
          this.$message.success('过单出库成功');
          this.$emit('success', response.data);
          this.handleClose();
        } else {
          this.$message.error(response.message || '过单出库失败');
        }
      } catch (error) {
        console.error('过单出库失败:', error);
        this.$message.error('过单出库失败');
      } finally {
        this.submitLoading = false;
      }
    },
    
    // 回退草稿
    async handleRollbackDraft() {
      try {
        this.submitLoading = true;
        
        const response = await toZYRetnExamine({
          id: this.rowData.id,
          state: 0 // 提交回退状态
        });
        
        if (response && response.code === 200) {
          this.$message.success('回退草稿成功');
          this.$emit('success', response.data);
          this.handleClose();
        } else {
          this.$message.error(response.message || '回退草稿失败');
        }
      } catch (error) {
        console.error('回退草稿失败:', error);
        this.$message.error('回退草稿失败');
      } finally {
        this.submitLoading = false;
      }
    },
    
    // 回退提交
    async handleRollbackSubmit() {
      try {
        this.submitLoading = true;
        
        const response = await toZYRetnExamine({
          id: this.rowData.id,
          state: 2 // 审核回退状态
        });
        
        if (response && response.code === 200) {
          this.$message.success('回退提交成功');
          this.$emit('success', response.data);
          this.handleClose();
        } else {
          this.$message.error(response.message || '回退提交失败');
        }
      } catch (error) {
        console.error('回退提交失败:', error);
        this.$message.error('回退提交失败');
      } finally {
        this.submitLoading = false;
      }
    },
    
    // 打印
    handlePrint() {
      this.$message.info('打印功能待实现');
    },
    
    // 截图保存
    handleScreenshot() {
      this.$message.info('截图保存功能待实现');
    },
    
    // 关闭对话框
    handleClose() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="less" scoped>
.dialog-container {
  height: 70vh;
  overflow-y: auto;
  padding: 0 20px;
  
  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin: 0 0 15px 0;
    padding-bottom: 8px;
    border-bottom: 1px solid #ebeef5;
  }
  
  .purchase-info-section {
    margin-bottom: 20px;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    
    .supplier-container {
      display: flex;
      align-items: center;
    }
  }
  
  .medicine-detail-section {
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    
    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      
      .section-title {
        margin: 0;
        border: none;
        padding: 0;
      }
    }
    
    .search-box {
      margin-bottom: 15px;
      display: flex;
      align-items: center;
    }
    
	.out-quantity-container {
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  gap: 8px;
	}
    .pagination-container {
      margin-top: 15px;
      display: flex;
      justify-content: center;
    }
    
    .summary-row {
      margin-top: 20px;
      padding: 15px;
      background-color: #f5f7fa;
      border-radius: 8px;
      display: flex;
      justify-content: flex-end;
      gap: 30px;
      
      .summary-item {
        font-size: 14px;
        color: #606266;
        
        .summary-label {
          font-weight: 500;
        }
        
        .summary-value {
          font-weight: 600;
          color: #409EFF;
          margin-left: 8px;
        }
      }
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 20px;
  border-top: 1px solid #ebeef5;
  
  .el-button {
    margin: 0 10px;
  }
}

.save-btn {
  color: #67C23A;
}

.cancel-btn {
  color: #909399;
}

/* 自定义对话框样式 */
/deep/ .addxyk-dialog {
  border-radius: 8px;
  
  .el-dialog__body {
    padding: 20px 0;
    max-height: calc(85vh - 120px);
    overflow: hidden;
  }
  
  .el-dialog__footer {
    padding: 15px 20px;
  }
}
</style>

<style>
/* 全局样式，不加scoped */
.zyk-outbound-drug-select-popper .el-select-dropdown__item {
  height: 60px !important;
  font-size: 12px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* 使用更具体的选择器覆盖默认选中样式 */
.zyk-outbound-drug-select-popper .el-select-dropdown__item.selected,
.zyk-outbound-drug-select-popper .el-select-dropdown__item.is-selected {
  color: #409EFF !important;
  font-weight: 700 !important;
  background-color: #f0f9ff !important;
}

/* 鼠标悬停状态 */
.zyk-outbound-drug-select-popper .el-select-dropdown__item:hover {
  background-color: #f5f7fa !important;
}
</style>

<style lang="less" scoped>
/deep/ .el-dialog__header {
	padding-bottom: 10px;
	background: linear-gradient(135deg, #ebfaff 0%, #00557f 100%);
	border-bottom: 1px solid #e8e8e8;
	border-radius: 8px;
	}

/deep/ .el-dialog__headerbtn .el-dialog__close{
	color: #ffffff;
}
/deep/ .el-dialog__headerbtn .el-dialog__close:hover{
	color: #000042;
	font-weight: bold;
}
</style>